import React, { useContext } from 'react'
import ModalPortal from '@Components/Popups/ModalPortal'
import Popup from '@Components/Popups/Popup'
import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import { useNavigate } from 'react-router'
import { StoresContext } from '@App/contexts'

interface CancelUploadModalProps {
    bulkUploadReviewModalIsOpen: boolean
    closeBulkUploadReviewModal: () => void
}

const CancelUploadModal = (props: CancelUploadModalProps) => {
    const navigate = useNavigate()
    const { rightsholderStore } = useContext(StoresContext)
    const { bulkUploadReviewModalIsOpen, closeBulkUploadReviewModal } = props

    const closeModalAndCancel = () => {
        closeBulkUploadReviewModal()
        navigate(Navigation.rightholder.createWork.bulk.root(rightsholderStore.currentRightsholderId))
    }

    return (
        <ModalPortal isOpen={bulkUploadReviewModalIsOpen} onClose={closeBulkUploadReviewModal}>
            <Popup onClose={closeBulkUploadReviewModal} className="cancel-confirmation">
                <div className="info-head">
                    <h3>Are you sure you want to cancel?</h3>
                    <p>
                        Canceling will remove all your bulk work upload progress. This may be a good idea if you want to
                        start over and make edits directly in your bulk file before re-uploading.
                    </p>
                </div>
                <div className="search-confirm-popup-content">
                    <div className="buttons-block">
                        <Button mainColor type="secondary" onClick={closeBulkUploadReviewModal}>
                            No
                        </Button>
                        <Button mainColor type="primary" onClick={() => closeModalAndCancel()}>
                            Yes, I want to cancel
                        </Button>
                    </div>
                </div>
            </Popup>
        </ModalPortal>
    )
}

export default CancelUploadModal
